import React from "react";
import styles from "./styles.module.css";

const PageTransition = ({ children }) => (
  <div className={styles.page}>{children}</div>
);

export default PageTransition;
